import Janus from '@bytewise/janus'

const JanusInstance = new Janus()

export default JanusInstance
